export const Capitalize = (str, lower = false) =>
	(lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
		match.toUpperCase()
	);

export const removeSerialNumberPrefix = (value) => {
	if (!value) return '';
	// Remove patterns like "1) ", "2) ", "10) " from the beginning of the string
	return value.replace(/^\d+\)\s*/, '');
};
